/**
 * Checks to see if the code is being executed on the server-side
 */
const isServerSide = typeof window === 'undefined'
export default isServerSide
